const formattedListElements = document.querySelectorAll(".layout-item-text-formatted");

if (formattedListElements) {
    formattedListElements.forEach((item) => {
        const olElement = item.querySelector("ol");
        if (olElement) {
            const listItems = olElement.querySelectorAll("li");
            listItems.forEach((li) => {
                const spanElement = li.querySelector("span");
                if(spanElement) {
                    const spanColor = window.getComputedStyle(spanElement).color;
                    
                    let color = "#000000"
                    
                    if(spanColor) {
                        color = spanColor
                    }

                    li.style.color = color;

                    // Apply the color to the ::marker pseudo-element
                    const style = document.createElement('style');
                    style.textContent = `
                        .custom-list-item::marker {
                            color: inherit !important;
                        }
                    `;
                    
                    // Append the style block to the document head
                    document.head.appendChild(style);
                    
                    // Add a class to the list item
                    li.classList.add('custom-list-item');
                }
                
            });
        }
    });
}
